import Model from "./Model";
import ContentModel from "./ContentModel";

export default class ArticleModel extends Model {
  id: number;
  title: string;
  group: string;

  static __typename: string = "Article";

  constructor(article: any, getters: any) {
    super(getters);
    this.id = article.id;
    this.title = article.title;
    this.group = article.group;
  }

  contents(): ContentModel[] {
    return this.getters
      .contentsByArticleId(this.id)
      .concat()
      .sort((A:ContentModel, B:ContentModel) => A.position - B.position);
  }

  legacyContent() {
    return this.contents().map((contentComponent: ContentModel) => {
      var content, url, size, origin, description;
      let behavior = contentComponent.behavior();
      switch (behavior) {
        case "text":
          content = contentComponent.text().body;
          break;
        case "video":
          content = contentComponent.video().providerId;
          break;
        case "image":
          let image = contentComponent.image();
          content = "";
          url = image.url;
          size = image.resizeFactor;
          origin = image.source ? image.source.origin : null;
          description = image.description;
          break;
      }
      return {
        behavior,
        content,
        url,
        size,
        origin,
        description
      };
    });
  }

  raw() {
    return {
      id: this.id,
      title: this.title,
      group: this.group,
      content: this.legacyContent(),
      __typename: ArticleModel.__typename
    };
  }
}